import isString from 'lodash/isString';
import includes from 'lodash/includes';

export default {
  
  isInViewport(element, margin) {
    margin = margin || 0;
    let rect = element.getBoundingClientRect();
    let html = document.documentElement;
    
    return (
      rect.top + margin >= 0 &&
      rect.left >= 0 &&
      rect.bottom - margin <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth)
    );
  },

  hasCssClass(element, cls){
    return element && element.classList && includes(element.classList, cls);
  },

  addCssClass(element, cls, parentElement){
    if(isString(element)){
      if(element.indexOf('.') === 0){
        let elements;
        if(parentElement) {
          elements = parentElement.querySelectorAll(element);
        }
        else {
          elements = document.getElementsByClassName(element.replace('.', ''));
        }

        for(let i = 0; i <= elements.length - 1; i++){
          this.addCssClass(elements[i], cls);
        }
      } else if(element.indexOf('#') === 0){
        if(parentElement) {
          element = parentElement.querySelector(element);
        }
        else {
          element = document.getElementById(element.replace('#', ''));
        }

        this.addCssClass(element, cls);
      }
    } else {
      if(element && element.classList && cls)
        element.classList.add(cls.trim());
    }
  },

  removeCssClass(element, cls, parentElement){
    if(isString(element)){
      if(element.indexOf('.') === 0){
        let elements;
        if(parentElement) {
          elements = parentElement.querySelectorAll(element);
        }
        else {
          elements = document.getElementsByClassName(element.replace('.', ''));
        }

        for(let i = 0; i <= elements.length - 1; i++){
          this.removeCssClass(elements[i], cls);
        }
      } else if(element.indexOf('#') === 0){
        if(parentElement) {
          element = parentElement.querySelector(element)
        }
        else {
          element = document.getElementById(element.replace('#', ''));
        }

        this.removeCssClass(element, cls);
      }
    } else {
      if(element && element.classList && cls)
        element.classList.remove(cls.trim());
    }
  },

  decodeHtml(domHelper){
    const toReplace = [
      ['&amp;', '&']
    ];

    for(let i = 0; i <= toReplace.length - 1; i++){
      let [before, after] = toReplace[i];
      domHelper = domHelper.replace(new RegExp(before, 'gi'), after);
    }

    return domHelper;
  },

  htmlToPlainText(html) {
    return this.decodeHtml(html).replace(/(?:<font color="[a-zA-Z0-9#(),]*">)|(?:<\/font>)|<\s*span[^>]*>/gi, "").replace(/<\/span>/gi, "");
  },

  clearFont(str){
    return str.replace(/(?:<font color="[a-zA-Z0-9#(),]*">)|(?:<\/font>)/gi, '');
  },

  copyToClipboard(textField) {
    textField.select();
    textField.setSelectionRange(0, 99999); /* For mobile devices */

    document.execCommand("copy");
  },

  pxToInt(px){
    return px && isString(px) ? parseInt(px.replace('px', '')) : px;
  }
}